<app-dashboard-card
	title="Risk Trend"
	subtitle="Financial and operational risk by business date"
>
	<button
		dashboardCardActions
		type="button"
		class="risk-trend-expand-button"
		title="View larger Risk Trend"
		[disabled]="loading || error || !trend || trend.length === 0"
		(click)="openExpandedChart()"
	>
		<i class="pi pi-expand"></i>
	</button>

	<div *ngIf="loading" class="dashboard-state">
		Loading risk trend...
	</div>

	<div
		*ngIf="!loading && error"
		class="dashboard-state dashboard-state-error"
	>
		Unable to load risk trend.
	</div>

	<div
		*ngIf="!loading && !error && (!trend || trend.length === 0)"
		class="dashboard-state"
	>
		Risk trend data is unavailable for the selected period.
	</div>

	<div
		*ngIf="!loading && !error && trend && trend.length > 0"
		class="risk-trend-chart"
	>
		<p-chart
			type="bar"
			[data]="chartData"
			[options]="chartOptions"
			width="100%"
			height="100%"
		></p-chart>
	</div>
</app-dashboard-card>

<p-dialog
	header="Risk Trend"
	[(visible)]="expanded"
	[modal]="true"
	[dismissableMask]="true"
	[draggable]="false"
	[resizable]="false"
	[closable]="true"
	[style]="{
		width: '85vw',
		maxWidth: '1200px'
	}"
	styleClass="risk-trend-dialog"
	appendTo="body"
>
	<div class="risk-trend-dialog-subtitle">
		Financial and operational risk by business date
	</div>

	<div class="risk-trend-expanded-chart">
		<p-chart
			type="bar"
			[data]="chartData"
			[options]="chartOptions"
			width="100%"
			height="100%"
		></p-chart>
	</div>
</p-dialog>
